import { StorageOfUniqueServices } from '@qality/common-service';
import { mapProjectToSelectOption } from '@qality/server-components/src/RecentAndMoreProjectSelect/RecentAndMoreProjectSelect.util';

import AP from './AP';
import API from './API';
import AdministeredProjectService from './AdministeredProjectService';
import AttachmentConfigService from './AttachmentConfigService';
import AttachmentService from './AttachmentService';
import AuthenticateService from './AuthenticateService';
import ContextParamsService from './ContextParamsService';
import ErrorHandlingUtils from './ErrorHandlingUtils';
import FlagCreator from './FlagCreator';
import HostNameService from './HostNameService';
import ImageService from './ImageService';
import IssueTypesService from './IssueTypesService';
import JQLSearchService from './JQLSearchService';
import JiraAdminSettingsService from './JiraAdminSettingsService';
import LicenseService from './LicenseService';
import ProjectServiceUnique from './ProjectServiceUnique';
import QAlityIssueTypeService from './QAlityIssueTypeService';
import ResizeService from './ResizeService';
import SettingServiceUnique from './SettingServiceUnique';
import TestCaseFieldMapper from './TestCaseFieldMapper';
import TestCaseRepositoryService from './TestCaseRepositoryService';
import TestCyclesServiceUnique from './TestCyclesServiceUnique';
import URLService from './URLService';
import WindowOriginService from './WindowOriginService';

export default {
  init() {
    StorageOfUniqueServices.add(
      'AdministeredProjectService',
      AdministeredProjectService
    );
    StorageOfUniqueServices.add('AP', AP);
    StorageOfUniqueServices.add('API', API);
    StorageOfUniqueServices.add(
      'AttachmentConfigService',
      AttachmentConfigService
    );
    StorageOfUniqueServices.add('AttachmentService', AttachmentService);
    StorageOfUniqueServices.add('AuthenticateService', AuthenticateService);
    StorageOfUniqueServices.add('ContextParamsService', ContextParamsService);
    StorageOfUniqueServices.add('ErrorHandlingUtils', ErrorHandlingUtils);
    StorageOfUniqueServices.add('FlagCreator', FlagCreator);
    StorageOfUniqueServices.add('HostNameService', HostNameService);
    StorageOfUniqueServices.add('IssueTypesService', IssueTypesService);
    StorageOfUniqueServices.add(
      'JiraAdminSettingsService',
      JiraAdminSettingsService
    );
    StorageOfUniqueServices.add('ProjectServiceUnique', ProjectServiceUnique);
    StorageOfUniqueServices.add(
      'QAlityIssueTypeService',
      QAlityIssueTypeService
    );
    StorageOfUniqueServices.add('ResizeService', ResizeService);
    StorageOfUniqueServices.add('SettingServiceUnique', SettingServiceUnique);
    StorageOfUniqueServices.add('TestCaseFieldMapper', TestCaseFieldMapper);
    StorageOfUniqueServices.add(
      'TestCyclesServiceUnique',
      TestCyclesServiceUnique
    );
    StorageOfUniqueServices.add('URLService', URLService);
    StorageOfUniqueServices.add('WindowOriginService', WindowOriginService);
    StorageOfUniqueServices.add('ImageService', ImageService);
    StorageOfUniqueServices.add('ProjectSelectUtils', {
      mapProjectToSelectOption,
    });
    StorageOfUniqueServices.add('LicenseService', LicenseService);
    StorageOfUniqueServices.add('JQLSearchService', JQLSearchService);
    StorageOfUniqueServices.add(
      'TestCaseRepositoryService',
      TestCaseRepositoryService
    );
  },
};
